module.exports = __webpack_public_path__ + "static/media/night.71915cd5.jpg";